export class UnitsOfService {
    category:string;
    id:number;
    modifiedByUserName: string;
    modifiedDate: Date; 
    mostRecent: boolean;
}
